// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"b1051ab7","309":"7274d911"}[chunkId] + ".chunk.js";
};